// @flow

import * as React from 'react';
import queryString from 'query-string';

import ConditionalRoute, {
  ConditionalRouteProps,
} from 'components/RouterProvider/ConditionalRoute';
import { connectUser } from 'components/RouterProvider/AuthorizationRoutes/connect';
import consts from 'consts/routing';

const { SIGN_IN } = consts;

const UserProtectedRoute = ({
  isSignedIn,
  config,
  ...props
}: ConditionalRouteProps & { isSignedIn: boolean }) => (
  <ConditionalRoute
    isConditionSatisfied={isSignedIn}
    config={{
      redirectTo: `${config.redirectTo}?${queryString.stringify({
        redirect_url: props.location?.pathname,
      })}`,
    }}
    {...props}
  />
);

UserProtectedRoute.defaultProps = {
  config: { redirectTo: SIGN_IN },
};

export default connectUser(UserProtectedRoute);
